export default {
  'zh-CN': {
    pleaseEnter: '请输入',
    search: '搜索'
  },
  'en': {
    pleaseEnter: 'please enter',
    search: '搜索_en'
  },
  'ja': {
    pleaseEnter: '入ってください',
    search: '搜索_ja'
  }
}
